import React, { useEffect } from 'react';
import FavoriteIcon from '@material-ui/icons/Favorite';
import GraphicEqIcon from '@material-ui/icons/GraphicEq';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import Hidden from '@material-ui/core/Hidden';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CustomTabs from 'components/CustomTabs/CustomTabs.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import Loader from 'components/Loader';
import CarouselDesktop from 'components/TrackCollectionCarouselDesktop';
import CarouselMobile from 'components/TrackCollectionCarouselMobile';
import config from 'config';

const tabs = [
  { tabName: 'Featured', tabIcon: LibraryMusicIcon, type: 'featured' },
  { tabName: 'New Releases', tabIcon: GraphicEqIcon, type: 'releases' },
  { tabName: 'Trending', tabIcon: FavoriteIcon, type: 'trending' },
];

export const TrackCollections = ({ tracks, onSelect }) => {
  useEffect(() => {
    onSelect(tabs[0].type);
  }, []);
  return (
    <Card
      profile
      style={{
        borderRadius: '20px 20px 0px 0px',
        padding: '50px 0px 0px 0px',
      }}
    >
      <CardBody
        profile
        style={{ textAlign: 'left', margin: '0px 10px 0px 10px' }}
      >
        <Card
          style={{
            borderRadius: '0px',
            width: '120%',
            minHeight: '330px',
            backgroundColor: '#F1F0FD',
            padding: '0px 20px',
            margin: '15px 0px 0 -30px',
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
          }}
          paper='true'
        >
          {/* Custom Tabs */}
          <CustomTabs
            onChange={(i) => onSelect(tabs[i].type)}
            headerColor='primary'
            tabs={tabs.map(({ tabIcon, tabName, type }) => {
              const list = (tracks[type] || []).slice(
                0,
                config.nbInDiscoverCarousel
              );
              return {
                tabIcon,
                tabName,
                tabContent: (
                  <div style={{ padding: '10px 0px 0px 25px' }}>
                    <GridContainer>
                      <GridContainer justify='center'>
                        <GridItem xs={12}>
                          <GridContainer style={{ margin: '0px 0px 10px 0px' }}>
                            <GridItem xs={12}>
                              <Hidden xsDown implementation='css'>
                                <div
                                  style={{
                                    padding: '0px 0px 0px 0px',
                                    margin: '0px 0px 20px 0px',
                                    borderRadius: '20px',
                                  }}
                                >
                                  {!list.length ? (
                                    <div style={{ marginTop: '110px' }}>
                                      <Loader />
                                    </div>
                                  ) : (
                                    <CarouselDesktop list={list} type={type} />
                                  )}
                                </div>
                              </Hidden>
                              <Hidden smUp implementation='css'>
                                <div
                                  style={{
                                    padding: '0px 0px 0px 0px',
                                    margin: '0px 20px 20px -25px',
                                    borderRadius: '20px',
                                  }}
                                >
                                  {!list.length ? (
                                    <div style={{ marginTop: '110px' }}>
                                      <Loader />
                                    </div>
                                  ) : (
                                    <CarouselMobile list={list} type={type} />
                                  )}
                                </div>
                              </Hidden>
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                    </GridContainer>
                  </div>
                ),
              };
            })}
          />
        </Card>
      </CardBody>
    </Card>
  );
};

export default TrackCollections;
